import { BaseAlgorithm } from './BaseAlgorithm';
import { CIDS } from '../../components/ProductsTable/constants';
import { debugLog, rankDebugLogEnable } from './ranking';

export class PowerSupplyAlgorithm extends BaseAlgorithm {
	constructor(usedFilters, filtersState) {
		super(usedFilters, filtersState);
		this.usedFilters = usedFilters;

		this.normIoTyp = 140;
		this.normIqTyp = 1;
		this.normFswTyp = 15;

		this.rankIoTyp = 0;
		this.rankIqTyp = 0;
		this.rankFswTyp = 0;

		this.weightIoTyp = 0.2;
		this.weightIqTyp = 0.15;
		this.weightFswTyp = 0.15;

		this.rIoTyp = 0;
		this.rIqTyp = 0;
		this.rFswTyp = 0;
	}
	logHeadingsToConsole() {
		if (rankDebugLogEnable) {
			console.log(
				'partNumber,part_IoTyp,rIoTyp,rankIoTyp,part_IqTyp,rIqTyp,rankIqTyp,part_FswTyp,rFswTyp,rankFswTyp,feRank'
			);
		}
	}

	execute(product) {
		debugLog.length = 0;
		debugLog.push(product[CIDS.PART_NUMBER]);

		// ---------------------------------------------Output Current  IOUT (A)---------------------------------------------

		[this.rankIoTyp, this.rIoTyp] = this.calculateRankSingleSliderGTE(CIDS.OUTPUT_CURRENT, product, this.normIoTyp);

		// ---------------------------------------------Quiescent Current  Iq Typ (mA)---------------------------------------------

		[this.rankIqTyp, this.rIqTyp] = this.calculateRankSingleSliderLTE(CIDS.QUIESCENT_CURRENT, product, this.normIqTyp);

		// ---------------------------------------------Switching frequency  fSW Typ (kHz)---------------------------------------------

		[this.rankFswTyp, this.rFswTyp] = this.calculateRankSingleSliderGTE(
			CIDS.SWITCHING_FREQUENCY,
			product,
			this.normFswTyp
		);

		// -------------------------------------------------------------------------------------------

		let feRank =
			this.weightIoTyp * this.rankIoTyp + this.weightIqTyp * this.rankIqTyp + this.weightFswTyp * this.rankFswTyp;
		let isPunished = false;
		debugLog.push(feRank);

		[feRank, isPunished] = super.punishPartsWithNullValueOfUsedFilters(product, this.usedFilters, feRank);

		let finalRank = (1 - this.weightIoTyp - this.weightIqTyp - this.weightFswTyp) * super.execute(product) + feRank;

		return isPunished ? finalRank / this.maxRankAfterPunish : finalRank;
	}
}
